import { createContext, ReactNode, useContext } from 'react';

export enum VerificationQueueMode {
    Verification = 'verification',
}

export const useVerificationQueueMode = () => {
    const verificationQueueMode = useContext(VerificationContext);
    return { verificationQueueMode };
};

export const VerificationContext = createContext<VerificationQueueMode | null>(null);

export const VerificationProvider = ({ mode, children }: { mode: VerificationQueueMode; children: ReactNode }) => {
    return <VerificationContext.Provider value={mode}>{children}</VerificationContext.Provider>;
};
